import { obtenerVentasPorPeriodo } from './ventas'

// Fecha local 'YYYY-MM-DD' a partir de un ISO string almacenado en UTC
function fechaLocal(isoString) {
  const d = new Date(isoString)
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

export function hoyLocal() {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

function desdeHaceDias(dias) {
  if (dias == null) return null
  const d = new Date()
  d.setDate(d.getDate() - dias)
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
}

// Filtra solo ventas (excluye abonos). Compatibilidad con ventas antiguas sin campo tipo.
function soloVentas(docs) {
  return docs.filter(d => d.tipo === 'venta' || !d.tipo)
}

export async function resumenDia(fecha) {
  // Consulta solo el rango de ese día (+/- 1 día de buffer para timezone)
  const todas = await obtenerVentasPorPeriodo(fecha, fecha)
  const ventas = soloVentas(todas).filter(v => fechaLocal(v.fecha) === fecha)

  const total = ventas.reduce((s, v) => s + v.total, 0)
  const count = ventas.length

  const porMetodo = {
    efectivo:      { total: 0, count: 0 },
    tarjeta:       { total: 0, count: 0 },
    transferencia: { total: 0, count: 0 },
    fiado:         { total: 0, count: 0 },
  }
  for (const v of ventas) {
    const m = v.metodoPago || 'efectivo'
    if (porMetodo[m]) { porMetodo[m].total += v.total; porMetodo[m].count++ }
  }

  return { fecha, total, count, promedio: count > 0 ? total / count : 0, porMetodo, ventas }
}

// dias: número de días hacia atrás, o null para todo el historial
export async function resumenPorDia(dias = 30) {
  const desde = desdeHaceDias(dias)
  const todas = await obtenerVentasPorPeriodo(desde)
  const ventas = soloVentas(todas)

  // Filtro preciso por fecha local (el range query ya viene con buffer de timezone)
  const filtradas = desde ? ventas.filter(v => fechaLocal(v.fecha) >= desde) : ventas

  const porDia = {}
  for (const v of filtradas) {
    const dia = fechaLocal(v.fecha)
    if (!porDia[dia]) porDia[dia] = { fecha: dia, total: 0, count: 0, fiados: 0 }
    porDia[dia].total += v.total
    porDia[dia].count++
    if (v.metodoPago === 'fiado') porDia[dia].fiados++
  }

  return Object.values(porDia).sort((a, b) => b.fecha.localeCompare(a.fecha))
}

export async function productosMasVendidos(dias = null) {
  const desde = desdeHaceDias(dias)
  const todas = await obtenerVentasPorPeriodo(desde)
  const ventas = soloVentas(todas)

  const filtradas = desde ? ventas.filter(v => fechaLocal(v.fecha) >= desde) : ventas

  const porProducto = {}
  for (const v of filtradas) {
    for (const item of (v.items || [])) {
      if (!porProducto[item._id]) {
        porProducto[item._id] = { _id: item._id, nombre: item.nombre, cantidad: 0, total: 0 }
      }
      porProducto[item._id].cantidad += item.cantidad
      porProducto[item._id].total += item.unidad === 'kg'
        ? (item.precioFinal ?? item.precio * item.cantidad)
        : item.precio * item.cantidad
    }
  }

  return Object.values(porProducto).sort((a, b) => b.cantidad - a.cantidad)
}
